import { deleteInternalTransferAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: deleteInternalTransferSlice, asyncAction: deleteInternalTransferAction } = createAsyncSlice(
  'deleteInternalTransferSlice',
  deleteInternalTransferAsync
);
